import { render, staticRenderFns } from "./Contable.vue?vue&type=template&id=dbe70060&lang=pug&"
import script from "./Contable.vue?vue&type=script&lang=js&"
export * from "./Contable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports